import { render, staticRenderFns } from "./CompanyNotifcationDialog.vue?vue&type=template&id=5a7802ba&"
import script from "./CompanyNotifcationDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyNotifcationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNotifcationDialog.vue?vue&type=style&index=0&id=5a7802ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports